export class SubmitForm {
  static execute(id: string, ...params: Parameter[]) {
    const form = document.getElementById(id) as HTMLFormElement;
    (params || []).forEach((it) => {
      const field = document.createElement('input');
      field.setAttribute('type', 'hidden');
      field.setAttribute('name', it.name);
      field.setAttribute('value', it.value);
      form.appendChild(field);
    });
    // formサブミット時にアニメーションを入れていたり、サイカタにデータを
    // 送信していたりするので、すぐに遷移させず若干遅延させる
    setTimeout(() => {
      form.submit();
    }, 100);
  }
}

export interface Parameter {
  name: string;
  value: any;
}
